Object.defineProperty(exports, "__esModule", { value: true })
exports.ChartColors = void 0

let ChartColors

(function (ChartColors) {
    ChartColors[ChartColors["NO_COLOR"] = 0] = "NO_COLOR"
    ChartColors[ChartColors["COLOR_BY_GENERATION"] = 1] = "COLOR_BY_GENERATION"
    ChartColors[ChartColors["COLOR_BY_SEX"] = 2] = "COLOR_BY_SEX"
    ChartColors[ChartColors["COLOR_BY_ETHNICITY"] = 3] = "COLOR_BY_ETHNICITY"
    ChartColors[ChartColors["COLOR_BY_NR_LANGUAGES"] = 4] = "COLOR_BY_NR_LANGUAGES"
    ChartColors[ChartColors["COLOR_BY_LANGUAGE"] = 5] = "COLOR_BY_LANGUAGE"
})

// eslint-disable-next-line
(ChartColors = exports.ChartColors || (exports.ChartColors = {}))